var buildMaps = function () {}; // buildMaps is a callback GET param value for calling Google Maps API in enqueue-scripts.php

(function ( $ ) {


    $(document).on('ready', function () {
        if ( typeof buildMaps !== "undefined" ) {
            buildMaps = function () {
                $('.acf-map').each(function () {
                    render_map($(this));
                });
            }
            buildMaps();
        }
    });


    function render_map( $el ) {

        var $markers = $el.find( '.marker' );

        // vars
        var args = {
            zoom: 13,
            center: new google.maps.LatLng( 0, 0 ),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            panControl: false,
            scrollwheel: false,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            keyboardShortcuts: false,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f05a2f"
                        }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f05a2f"
                        },
                        {
                            "gamma": "1"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#f05a2f"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "weight": "0.4"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f05a2f"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f05a2f"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "lightness": "0"
                        },
                        {
                            "saturation": "50"
                        },
                        {
                            "gamma": "1.00"
                        },
                        {
                            "visibility": "on"
                        },
                        {
                            "weight": "0.01"
                        },
                        {
                            "invert_lightness": true
                        },
                        {
                            "hue": "#ff8700"
                        }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#df532b"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        }
                    ]
                }
            ]
        };

        // create map
        var locationsMap = new google.maps.Map( $el[0], args );

        // add a markers reference
        locationsMap.markers = [];

        // add markers
        $markers.each( function() {
            add_marker( $( this ), locationsMap );
        } );

        // center map
        center_map( locationsMap );
    }

    var infowindow;


    function add_marker( $marker, map ) {
        // var
        var latlng = new google.maps.LatLng( $marker.attr( 'data-lat' ), $marker.attr( 'data-lng' ) );

        // create marker
        var marker = new google.maps.Marker( {
            position: latlng,
            map: map,
            icon: $marker.data('marker-icon') //uncomment if you use custom marker
        } );

        // adding place_id to marker instance to be able to loop through markers list and hide particular marker identifying it by place_id
        marker.locationPlaceId = $marker.attr( 'data-place-id' );

        // add to array
        map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if ( $.trim( $marker.html() ) ) {
            // create info window
            infowindow = new google.maps.InfoWindow();

            // show info window when marker is clicked
            google.maps.event.addListener( marker, 'click', function(e) {


                infowindow.close(); // Close previously opened infowindow, fill with new content and open it
                infowindow.setContent( $marker.html() );
                infowindow.open( map, marker );

            } );
        }
    }


    function center_map( map ) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ) {
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
        } );

        // only 1 marker?
        if ( map.markers.length === 1 ) {
            // set center of map
            map.setCenter( bounds.getCenter() );
        } else {
            // fit to bounds
            map.fitBounds( bounds );
        }
    }

})( jQuery )